import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

/**处理支付宝支付回调 */
export default () => {
  let { paymentStr } = useParams();
  useEffect(() => {
    window.history.replaceState("", "", localStorage.getItem(paymentStr));
  }, []);
  return null;
};
